<template>
  <div class="search-select-parent">
    <div class="search-select">
      <div
        class="select-list"
        v-for="(item, index) in options"
        :key="index"
        :class="{'select-list-up': item.up}"
        v-show="item.show"
      >
        <div class="left">
          <div class="head">{{item.label}}：</div>
        </div>

        <div class="middle" :id="`middle-${index}`">
          <div
            class="last"
            :class="{'last-active': item.active}"
            v-for="(item) in item.value"
            :key="item.value"
            @click="select(index, item)"
            v-show="item.show"
          >
            {{item.label}}
            <i class="el-icon-close" v-show="item.active && item.type != 'all'"></i>
          </div>
        </div>

        <div class="right" v-show="isShouldShow(index)">
          <div class="more" @click="item.up = !item.up">
            <div class="down" v-if="item.up">
              更多
              <i class="el-icon-arrow-down"></i>
            </div>
            <div class="up" v-else>
              收起
              <i class="el-icon-arrow-up"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="selected-list" v-show="selected.length > 0">
      <div class="left">
        <div class="head">已选标签：</div>
      </div>
      <div class="middle">
        <div class="list">
          <div class="last" v-for="(item, index) in selected" :key="index" @click="close(item)">
            {{item.label}}
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="clear" @click="clear">
          <i class="el-icon-delete"></i>
          清空
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchSelect",
  props: {
    options: {
      type: Array,
      required: true,
      default: []
    },
    rules: {
      type: Array,
      required: false,
      default: []
    }
  },
  computed: {
    selected: function() {
      let result = [];
      this.options.forEach(e => {
        e.value
          .filter(e => e.type === "tag")
          .forEach(e => {
            if (e.active) {
              result.push(e);
            }
          });
      });

      return result;
    }
  },
  methods: {
    isShouldShow(index) {
      const e = document.querySelector("#middle-" + index);
      return e ? e.clientHeight > 41 : false;
    },
    isNotChild(parentArray, e) {
      return parentArray.indexOf(e) < 0;
    },
    change(e) {
      this.rules.map(rule => {
        const parentLevel = rule[0];
        const childLevel = rule[1];

        if (e.level === childLevel) {
          return;
        }
        // 1. 恢复初始状态
        this.options
          .find(e => e.level === childLevel)
          .value.filter(e => e.type === "tag")
          .map(e => {
            e.active = false;
            e.show = true;
          });
        this.options
          .find(e => e.level === childLevel)
          .value.filter(e => e.type === "all")
          .map(e => {
            e.active = true;
            e.show = true;
          });
        // 2. 获取选中的标签
        // 3. 根据选中的标签调整
        if (
          this.options
            .find(e => e.level === parentLevel)
            .value.filter(e => e.active && e.type === "tag").length > 0
        ) {
          this.options
            .find(e => e.level === childLevel)
            .value.filter(e => e.type === "tag")
            .filter(el =>
              this.options
                .find(e => e.level === parentLevel)
                .value.filter(e => e.active && e.type === "tag")
                .map(e => this.isNotChild(el.parent, e.value))
                .reduce((a, b) => a && b, true)
            )
            .map(e => {
              e.active = false;
              e.show = false;
            });
        }
      });

      this.$emit("change", e, this.options);
    },
    select(index, e) {
      if (e.type === "all") {
        this.options[index].value.map(e => {
          e.active = false;
        });
        e.active = true;
      } else {
        this.options[index].value
          .filter(e => e.type === "all")
          .map(e => (e.active = false));
        e.active = !e.active;
      }

      if (this.options[index].value.filter(e => e.active).length <= 0) {
        this.options[index].value
          .filter(e => e.type === "all")
          .map(e => (e.active = true));
      }

      this.change(e);
    },
    close(e) {
      e.active = false;

      this.options.forEach(o => {
        if (o.value.filter(e => e.active).length <= 0) {
          o.value.filter(e => e.type === "all").map(e => (e.active = true));
        }
      });

      this.change(e);
    },
    clear() {
      this.options.forEach(o => {
        o.value.forEach(e => {
          if (e.type === "tag") {
            e.active = false;
          }
        });

        if (o.value.filter(e => e.active).length <= 0) {
          o.value.filter(e => e.type === "all").map(e => (e.active = true));
        }
      });

      this.change(null);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-select-parent {
  width: 1100px;
  //   margin: 0 auto;
  margin: 30px auto;
}

.selected-list {
  margin-top: 20px;

  .left,
  .middle,
  .right {
    vertical-align: top;
    display: inline-block;
  }

  .left {
    width: 100px;
  }

  .middle {
    width: 940px;
  }

  .right {
    width: 48px;
  }

  .head {
    display: inline-block;
    padding: 0 20px;
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(132, 135, 145, 1);
    line-height: 17px;
  }

  .list {
    display: inline-block;

    .last {
      display: inline-block;
      vertical-align: top;
      height: 17px;
      margin-right: 10px;
      margin-bottom: 10px;
      border: 1px solid rgba(194, 139, 43, 1);
      cursor: pointer;
      padding: 4px;
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(194, 139, 43, 1);
      line-height: 17px;

      .el-icon-delete {
        color: #000;
      }
    }
  }

  .clear {
    cursor: pointer;
    float: right;
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(136, 136, 136, 1);
    line-height: 17px;

    .el-icon-delete {
      font-size: 16px;
      vertical-align: bottom;
    }
  }
}

.search-select {
  width: 1098px;
  border-top: 1px solid rgba(228, 200, 150, 1);
  border-left: 1px solid rgba(228, 200, 150, 1);
  border-right: 1px solid rgba(228, 200, 150, 1);

  .select-list {
    width: 100%;
    line-height: 39px;
    border-bottom: 1px solid rgba(228, 200, 150, 1);

    .left,
    .middle,
    .right {
      vertical-align: top;
      display: inline-block;
    }

    .left {
      width: 100px;
    }

    .middle {
      width: 940px;
    }

    .right {
      width: 48px;
    }

    .head {
      //   width: 50px;
      margin: 0 18px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(132, 135, 145, 1);
    }

    .last {
      display: inline-block;
      margin: 7px 7px 7px 0;
      padding: 0 7px;
      height: 25px;
      line-height: 25px;

      font-size: 12px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      cursor: pointer;
      user-select: none;
    }

    .last-active {
      background: rgba(228, 200, 150, 1);
    }

    .more {
      cursor: pointer;
      margin: 7px 0;
      padding: 4px 0;
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(194, 139, 43, 1);
      line-height: 17px;
    }
  }

  .select-list-up {
    max-height: 41px;
    overflow: hidden;
  }
}
</style>